import React, {PureComponent} from 'react';
import {Alert, Modal, Button } from 'react-bootstrap';
import _ from 'lodash';
import { dialogHeaderFooterBgColor, errorBackgroundColor } from '../../helpers/colors';

class ServerError extends PureComponent {
    constructor(props) {
        super(props);
        this.reduceErrors = this.reduceErrors.bind(this);
        this.state = {
            dialogCancel: () => {
                this.setState({dialogOpen: false});
                if (this.props.close) {
                    this.props.close();
                }
            },
            dialogOpen: false
        };
    }

    componentWillReceiveProps(nextProps) {
        let error = this.reduceErrors(nextProps.error);
        this.setState({dialogOpen: error.length > 0});
    }

    reduceErrors(error) {
        let errorOut = error;
        if (error instanceof Error) {
            errorOut = [error.message];

        } else if (_.isObject(error)) {
            errorOut = [JSON.stringify(error, null, 2)];
        } else if (!_.isArray(error)) {
            errorOut = [error];
        }

        errorOut = errorOut.filter((value) => {
            return !(_.isUndefined(value) || value == '');
        });

        return errorOut;
    }

    render() {
        const {
            error,
            style
        } = this.props;

        let alert = (<div/>);
        let errorOut = this.reduceErrors(error);
        if (errorOut.length > 0) {
            if (!style || style === 'inline') {
                alert = (
                    <Alert bsStyle='danger' style={{ backgroundColor:errorBackgroundColor }}>
                        {errorOut.map((value, index) => {return (<pre data-hj-whitelist key={index} style={{ backgroundColor: 'inherit', fontColor: 'inherit', border: 'none 0' }}>{value}</pre>);})}
                    </Alert>);

            } else if (style == 'popup') {
                alert = (
                    <Modal show={this.state.dialogOpen}
                           onHide={this.state.dialogCancel}
                           backdrop='static'
                    >
                        <Modal.Header closeButton style={{ backgroundColor: errorBackgroundColor }}>
                            <Modal.Title data-hj-whitelist>Error</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                        <ul>
                        {errorOut.map((value, index) => {return (<pre data-hj-whitelist key={index} style={{ backgroundColor: 'inherit', fontColor: 'inherit', border: 'none 0' }}>{value}</pre>);})}
                        </ul>
                        </Modal.Body>
                    </Modal>
                );
            }
        }

        return alert;
    }
}

export default ServerError;
